<template>
  <d-modal
    size="lg"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('settings.confirmations.searchProducts.title') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="confirmation-search-products-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('settings.confirmations.searchProducts.search') }}:
            </label>

            <div class="d-flex">
              <validation-provider
                rules="required|min:2"
                name="search"
                class="w-75"
                v-slot="{ errors }">
                <d-input
                  :state="errors.length ? 'invalid' : null"
                  v-model="search" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>

              <d-button
                :disabled="!search || search.length < 2"
                class="ml-2 w-25"
                theme="success"
                @click.prevent="searchProducts">
                <i class="material-icons">search</i>
                {{ $t('settings.confirmations.searchProducts.searchProducts') }}
              </d-button>
            </div>
          </div>
        </validation-observer>

        <d-alert
          v-if="loadingInProgress"
          theme="light"
          class="text-center"
          show>
          {{ $t('ui.dataLoading') }}...
        </d-alert>

        <d-alert
          v-if="noProductsFound"
          theme="warning"
          class="text-center"
          show>
          {{ $t('settings.confirmations.searchProducts.noProductsFounded') }}
        </d-alert>

        <strong
          v-if="foundedProducts.length"
          class="d-block mt-2 mb-4">
          {{ $t('settings.confirmations.searchProducts.foundedProducts') }} ({{ foundedProducts.length }}):
        </strong>

        <ol v-if="foundedProducts.length">
          <li
            v-for="(product, index) of foundedProducts"
            :key="'product-' + index">
            {{ product.code }} - {{ product.name }}
          </li>
        </ol>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        :disabled="!foundedProducts.length"
        class="ml-auto"
        theme="success"
        @click.prevent="addProducts">
        <i class="material-icons">add</i>
        {{ $t('settings.confirmations.searchProducts.addFoundedProducts') }} ({{ foundedProducts.length }})
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'confirmation-search-products-popup',
  data () {
    return {
      foundedProducts: [],
      search: '',
      loadingInProgress: false,
      noProductsFound: false
    };
  },
  methods: {
    handleClose () {
      this.$bus.$emit('confirmation-search-products-popup-close');
    },
    searchProducts () {
      this.loadingInProgress = true;
      this.noProductsFound = false;

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/products/items',
        outputKey: 'foundedProducts',
        errorKey: 'loadProductsError',
        params: {
          where: {
            search: this.search
          },
          return: 'get'
        },
        successAction: (response) => {
          this.loadingInProgress = false;

          if (response.length === 0) {
            this.noProductsFound = true;
          }
        }
      });
    },
    addProducts () {
      this.$bus.$emit('confirmation-search-products-results', this.foundedProducts.map(product => ({
        id: product.id,
        code: product.code,
        name: product.name
      })));

      this.handleClose();
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
